import { Table, TableRow } from '@material-ui/core'
import React, { useCallback, useEffect, useState } from 'react'
import { useSummaryRowStyles } from 'components/Order/OrderTable/FinancialSummaryRow/styles'
import { momentToISOLocalDate } from 'utils/date'
import moment from 'moment'
import { getOrderFinancialSummary } from 'services'
import { useErrorHandling } from 'context/errorHandling'
import { FinancialSummaryContent } from './FinancialSummaryContent'

export function FinancialSummaryRow ({ filters }) {
  const { handleError } = useErrorHandling()

  const classes = useSummaryRowStyles()
  const [financialSummary, setFinancialSummary] = useState()

  const formatFilters = useCallback(() => {
    return filters.map(({ key, value }) => {
      if (key === 'creationDateGe' || key === 'creationDateLe') {
        return ({
          key: key,
          value: momentToISOLocalDate(moment(value))
        })
      }
      return ({ key, value })
    })
  }, [filters])

  const refreshRowContent = useCallback(() => {
    const newFilters = formatFilters()
    getOrderFinancialSummary(newFilters)
      .then(setFinancialSummary)
      .catch(handleError)
  }, [handleError, formatFilters])

  useEffect(() => {if (filters) return refreshRowContent()}, [filters, refreshRowContent])

  return <Table className={classes.summaryRowTable}>
    <TableRow className={classes.tableRow}>
      <FinancialSummaryContent financialSummary={financialSummary}/>
    </TableRow>
  </Table>
}
